"use strict";

import axios from "axios";
import store from '@/store'
import errorCdoe from '@/plugins/utils/error-code'
let axiosSource = axios.CancelToken.source()
let config = {
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
};

const _axios = axios.create(config);

const checkNull = function (value) {
  return value.some(it => it == "undefined") || value.some(it => it == "null")
}

_axios.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV == "development") {
      config.headers['Authorization'] = '077a2c1cd42148b98e2e96a5b589f06aKPXtRPgqjnh76HUCfhf9orpU6iKUmH5qQTEEoS7eyaQpTA0ry8zFP89ajZk9AhyjJfj2YMMKPX'
    }
    if (store.getters.getmember.token) config.headers['TOKEN'] = store.getters.getmember.token
    if (store.getters.getmember.pid) config.headers['LOID'] = store.getters.getmember.pid
    let urlArray = config.url.split('/')
    if (checkNull(urlArray)) throw new Error('API URL undefined');
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    if (response.status === 200) errorCdoe.checkState(response)
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default {
  Get (url, params = {}) {
    return _axios.get(url, { cancelToken: axiosSource.token })
      .then(res => res.data)
      .catch(error => {
        throw error
      })
  },
  Post (url, params = {}) {
    return _axios.post(url, params, { cancelToken: axiosSource.token })
      .then(res => res.data)
      .catch(error => {
        throw error
      })
  },
  fileUpload (formData) {
    return _axios.post(process.env.VUE_APP_UPDATE_API, formData)
      .then(res => res.data)
      .catch(error => {
        throw error
      })
  },
  url: {
    v1: `${process.env.VUE_APP_HIGH_API}/v1`,
    six: `${process.env.VUE_APP_HIGH_API}/v1/six`,
    hfl: `${process.env.VUE_APP_HIGH_API}/v1/hfl`,
    Newcommon: `${process.env.VUE_APP_HIGH_API}/v1/common`,
    exgame: `${process.env.VUE_APP_HIGH_API}/v1/exgame`,
    ip: `${process.env.VUE_APP_IP_API}`,
  }
}
